
// TODO: is this how we want to handle broadcasts? not sure yet
const badgeBroadcastChannel = new BroadcastChannel('appBadge');
export const updateAppBadge = (count: number) => {
    badgeBroadcastChannel.postMessage(count);
}